import React, { createContext, useContext, ReactNode } from 'react';
import { useNetworkingOptimized } from '@/hooks/useNetworkingOptimized';

const NetworkingContext = createContext<ReturnType<typeof useNetworkingOptimized> | null>(null);

export const NetworkingProvider = ({ children }: { children: ReactNode }) => {
  // PHASE 2: Enable polling only in NetworkingContext
  const networkingData = useNetworkingOptimized({ enablePolling: true });
  return (
    <NetworkingContext.Provider value={networkingData}>
      {children}
    </NetworkingContext.Provider>
  );
};

export const useNetworking = () => {
  const context = useContext(NetworkingContext);
  return context || {
    networkingStats: { 
      unreadMessages: 0, 
      pendingRequests: 0,
      sentPendingRequests: 0,
      totalConnections: 0,
      totalMessages: 0
    },
    connections: [],
    connectionRequests: [],
    messages: [],
    loading: true,
    sendMessage: async () => {},
    respondToConnectionRequest: async () => {},
    sendConnectionRequest: async () => {}
  };
};
